// Depends
import { group, route, meta } from '@/helpers/routes'

import Login from './login/routes'
import Register from './register/routes'
import Terms from './terms/routes'
import Reset from './reset/reset'
import Forgot from './forgot/forgot'
import TenantActive from './active/routes'

const routes = group('/app/auth', [
  route('reset', '/reset', Reset, meta('Recupera a senha', false, 'guest')),
  route('forgot', '/forgot', Forgot, meta('Esqueci minha senha', false, 'guest'))
])

export default [
  ...group('/app/auth', Login),
  ...group('/app/register', Register),
  ...group('/app/terms', Terms),
  ...group('/app/auth/tenant', TenantActive),
  ...routes
]



// WEBPACK FOOTER //
// ./src/app/auth/routes.js